module.exports = __webpack_public_path__ + "static/Logo-21d1a355254669cbd5c2b5dbced4f5de.png";